import type { PropsWithChildren } from 'react'

export const SectionTitle = ({ children }: PropsWithChildren) => (
	<p className={'text-center font-bold text-2xl md:text-[36px]'}>{children}</p>
)
